// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { deepPropHasChanged } from '../../../utils/react/propsComparisons';

// Selectors
import { getCurrentUser } from '../../currentUserSelector';

// Actions
import { getCurrentUserGoogleContacts } from '../googleContactsActions';
import { hasGoogleScope } from '../../../../common/users/utils/userPropertyUtils';

// Constants
import { GOOGLE_SCOPES } from '../../../../common/utils/googleUtils';

const userGoogleScopeHasChanged = deepPropHasChanged(['currentUser', 'google', 'scope']);

const mapStateToProps = createStructuredSelector({
    currentUser: getCurrentUser,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchGetGoogleContacts: (force) => dispatch(getCurrentUserGoogleContacts({ force })),
});

export default (DecoratedComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class fetchGoogleContactsOnMountDecorator extends React.Component {
        componentWillMount() {
            this.getGoogleContacts(this.props);
        }

        componentWillReceiveProps(nextProps) {
            if (userGoogleScopeHasChanged(this.props, nextProps)) this.getGoogleContacts(nextProps);
        }

        getGoogleContacts = (props) => {
            const { currentUser, dispatchGetGoogleContacts } = props;

            if (!currentUser || !hasGoogleScope(currentUser, GOOGLE_SCOPES.contacts_read_only)) return;

            dispatchGetGoogleContacts();
        };

        render() {
            return <DecoratedComponent {...this.props} />;
        }
    }

    fetchGoogleContactsOnMountDecorator.propTypes = {
        currentUser: PropTypes.object,
        dispatchGetGoogleContacts: PropTypes.func,
    };

    return fetchGoogleContactsOnMountDecorator;
};
